module.exports = __webpack_public_path__ + "img/help-banner.3765e17c.jpg";